import { Fragment } from 'react';
import cn from 'classnames';
import { Link } from '@framework/router/Next/Link';
import { getIssuerRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';
import { collectValidIssuers } from '@/creditflowresearch/ui/components/deals/DealListTable/cells/IssuersCellLegacy/helpers';
import { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import linkStyles from '@creditflowresearch/uilib/styles/helpers/link.module.scss';

import styles from './issuersCell.module.scss';

const IssuersCell = ({ row: deal, maxWidth }: ICellProps & { maxWidth: number }) => {
  const issuerList = collectValidIssuers(deal);
  return (
    <span className={ styles.links } style={ { maxWidth } }>{
      issuerList.map((issuer, index, arr) => issuer.viewId && (
        <Fragment key={ issuer.viewId }>
          <Link to={ getIssuerRoute(issuer) } className={ cn(styles.link, linkStyles.link) } key={ issuer.viewId }>
            { issuer.name }
          </Link>
          { index !== arr.length - 1 && ', ' }
        </Fragment>
      ))
    }
    </span>
  );
};

export default IssuersCell;
